// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorPage_kJilX {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    background-color: #ffff;
    padding: 20px;
    width: 100%;
    border-radius: 20px 0px 0px 0px;
}

.errorContent__JU1p {
    text-align: center;
}

.errorIcon_xkt9a {
    font-size: 64px;
    color: #dc3545;
    margin-bottom: 24px;
}

.errorTitle_NWPDG {
    font-size: 28px;
    color: #212529;
    margin-bottom: 16px;
    font-weight: 600;
}

.errorText_t3Q2f {
    font-size: 16px;
    color: #6c757d;
    margin-bottom: 32px;
    line-height: 1.5;
}

.buttonContainer_DCuzo {
    display: flex;
    gap: 16px;
    justify-content: center;
}

.primaryButton_B3oTJ {
    padding: 12px 24px;
    background-color: #0d6efd;
    color: var(--white-color);
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.primaryButton_B3oTJ:hover {
    background-color: #0b5ed7;
}

.secondaryButton_nGyEa {
    padding: 12px 24px;
    background-color: #6c757d;
    color: var(--white-color);
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.secondaryButton_nGyEa:hover {
    background-color: #5c636a;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ErrorPage/ErrorPage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".errorPage {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100%;\n    background-color: #ffff;\n    padding: 20px;\n    width: 100%;\n    border-radius: 20px 0px 0px 0px;\n}\n\n.errorContent {\n    text-align: center;\n}\n\n.errorIcon {\n    font-size: 64px;\n    color: #dc3545;\n    margin-bottom: 24px;\n}\n\n.errorTitle {\n    font-size: 28px;\n    color: #212529;\n    margin-bottom: 16px;\n    font-weight: 600;\n}\n\n.errorText {\n    font-size: 16px;\n    color: #6c757d;\n    margin-bottom: 32px;\n    line-height: 1.5;\n}\n\n.buttonContainer {\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n}\n\n.primaryButton {\n    padding: 12px 24px;\n    background-color: #0d6efd;\n    color: var(--white-color);\n    border: none;\n    border-radius: 6px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.primaryButton:hover {\n    background-color: #0b5ed7;\n}\n\n.secondaryButton {\n    padding: 12px 24px;\n    background-color: #6c757d;\n    color: var(--white-color);\n    border: none;\n    border-radius: 6px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.secondaryButton:hover {\n    background-color: #5c636a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPage": `errorPage_kJilX`,
	"errorContent": `errorContent__JU1p`,
	"errorIcon": `errorIcon_xkt9a`,
	"errorTitle": `errorTitle_NWPDG`,
	"errorText": `errorText_t3Q2f`,
	"buttonContainer": `buttonContainer_DCuzo`,
	"primaryButton": `primaryButton_B3oTJ`,
	"secondaryButton": `secondaryButton_nGyEa`
};
export default ___CSS_LOADER_EXPORT___;
